import { useNavigate } from "react-router-dom";

function PostCard({ post }) {
  const navigate = useNavigate();

  return (
    <div
      className="card"
      onClick={() => navigate(`/post/${post.id}`)}  // ✅ FIXED HERE
    >
      <img
        src={`https://picsum.photos/200?random=${post.id}`}
        alt="post"
      />

      <h3>{post.title.slice(0, 20)}...</h3>

      <p>
        {post.body.slice(0, 60)}
        {post.body.length > 60 && " Read More..."}
      </p>
    </div>
  );
}

export default PostCard;